import { useState, memo } from 'react';
import { Tooltip, ButtonProps } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import { useClipboard } from 'use-clipboard-copy';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { SxProps } from '@mui/system';

export const CopyToClipboardButton = memo(
    (props: { text: string; sx?: SxProps; size?: ButtonProps['size']; hide?: boolean }) => {
        const [copied, setCopied] = useState(false);
        const { copy } = useClipboard();

        const style: SxProps = {
            ...props.sx,
            fontSize: props.size === 'small' ? '1rem' : '1.5rem',
            visibility: props.hide ? 'hidden' : 'inherit',
            verticalAlign: 'middle',
        };

        const onCopy = () => {
            copy(props.text);
            setCopied(true);
            setTimeout(() => setCopied(false), 3000);
        };

        return copied ? (
            <Tooltip title="Copied">
                <DoneIcon color="success" sx={style} cursor="pointer" />
            </Tooltip>
        ) : (
            <Tooltip title="Copy">
                <ContentCopyIcon sx={style} cursor="pointer" onClick={onCopy} />
            </Tooltip>
        );
    },
);

CopyToClipboardButton.displayName = 'CopyToClipboardButton';
